import { Alert } from "antd";
import React, { useMemo, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import BackButton from "../buttons/BackButton";
import { selectUser } from "../../redux/slices/auth.slice";
import getBoardApi from "./boardApi";
import BoardDiscussions from "./BoardDiscussions";
import BoardOverview from "./BoardOverview";
import BoardPosts from "./BoardPosts";
import BoardSyllabus from "./BoardSyllabus";


function SwitchCourseBoard({
  classId,
  groupId,
  scope = "class",
  showBackButton = true,
}) {
  const [step, setStep] = useState(1);
  const user = useSelector(selectUser);
  const canEdit = user?.role === "admin" || user?.role === "super_admin";

  const isGroupScope = scope === "group";


  const isGroupAdmin = !!user?.group || user?.role === "super_admin";

  const preliminaryApi = useMemo(
    () => getBoardApi({ scope, classId, groupId }),
    [scope, classId, groupId],
  );

  const board = useQuery(preliminaryApi.keys.board, preliminaryApi.fetchBoard, {
    enabled: preliminaryApi.enabled,
    retry: false,
  });

  const className = board.data?.class?.name;

  const viewOnly =
    !isGroupScope && !isGroupAdmin && !!board.data?.group_view_only;

  // Rebuilt once the class name is known, since the curriculum export names its
  // file after the class.
  const api = useMemo(
    () => getBoardApi({ scope, classId, className, groupId }),
    [scope, classId, className, groupId],
  );

  const tabs = [
    { key: 1, label: "About" },
    { key: 2, label: "Curriculum" },
    { key: 3, label: "Schedule" },
    { key: 4, label: "Discussions" },
  ];

  function switchTab() {
    switch (step) {
      case 2:
        return <BoardPosts api={api} canEdit={canEdit} viewOnly={viewOnly} />;
      case 3:
        return <BoardSyllabus api={api} canEdit={canEdit} viewOnly={viewOnly} />;
      case 4:
        return <BoardDiscussions api={api} canEdit={canEdit} />;
      case 1:
      default:
        return (
          <BoardOverview
            api={api}
            board={board.data}
            isLoading={board.isLoading}
            canEdit={canEdit}
          />
        );
    }
  }

  // A 403 here means the class is not this user's to see — say so plainly rather
  // than rendering four empty tabs.
  if (board.isError) {
    return (
      <div className="p-8">
        <Alert
          type="error"
          showIcon
          message="Course board unavailable"
          description={
            board.error?.response?.status === 403
              ? "You do not have access to this course board."
              : "Could not load this course board. Please try again."
          }
        />
      </div>
    );
  }

  return (
    <div className="p-8">
      {showBackButton && (
        <div className="p-4 text-right">
          <BackButton />
        </div>
      )}

      <div className="grid grid-cols-4 bg-white rounded-lg">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            onClick={() => setStep(tab.key)}
            className={`iskool-tab-item ${
              step === tab.key ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            {tab.key === 1 ? (
              <div>
                <div className="text-xs">
                  {isGroupScope ? "All Junior Branches" : className || "Class"}
                </div>
                <div className="text-lg">About</div>
              </div>
            ) : (
              <div className="text-lg">{tab.label}</div>
            )}
          </div>
        ))}
      </div>

      <div>{switchTab()}</div>
    </div>
  );
}

export default SwitchCourseBoard;
